module.exports = __webpack_public_path__ + "assets/img/Superdraft-Social-Static-Ad-w720.acb8cb45.png";